module.exports = __webpack_public_path__ + "img/green-payment-card.2ac605b0.svg";